<template>
  <div class="first" v-if="productTypes">
    <div style="display: flex;">
      <div class="right">
        <div class="no-data" v-if="!productChoosedList.length">{{ $t('main.noData') }}</div>
        <div v-else class="pContent cPointer" v-for="(v, ind) in productChoosedList" :key="ind" @click="goToDetail(v)">
          <img :src="v.image" class="pImg" />
          <div class="pName">{{ v.name }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import { getProductTypeNavList } from "@/api";
export default {
  props: {
    productTypes: {
      require: true,

      default: function() {
        return [];
      }
    },
    firstIndex:{
      require: true,
      default: function() {
        return []
      },
    }
  },
  data() {
    return {
      productChoosedList:[],
      templates: {
        index: "/",
        single_intro: "/about",
        single_map: "/service/map",
        single_term: "/service/term",
        single_contact: "/contact",
        category_product: "/product",
        category_product_more: "/product/more",
        detail_product:"/product/detail",
        category_join: "/contact",
        category_steps: "/service/steps",
        category_news: "/news",
        category_productDirectory: "/service",
        detail_article: "/news/detail",
      }
    };
  },
  watch: {
    "$store.state.siteInfo": function(newV) {
      this.getProductListNav();
    }
  },
  mounted(){
    this.getProductListNav();
  },
  methods: {
    goToDetail(item) {
      //console.log(item);
      this.$router.push({
        path: this.getRoutesPath(item['list_template'], item['identification'], item['id'])
      });
    },
    getRoutesPath(template, identification, id) {
      let basePath  = this.templates['detail_product'];
      let paramsUrl = '';
      if (identification !== '') {
        paramsUrl = '/'+identification;
      } else if (id !== 'productCenter' && id !== 'index' && id !== '0') {
        paramsUrl = '/'+id;
      } else {
        paramsUrl = '';
      }

      return basePath + paramsUrl;
    },
    getProductListNav() {
      const params = {
        "req": {
          "page": 1,
          "where": [
            {
              "condition": "1",
              "filed": "posid",
              "expression": "="
            },
            {
              "condition": Cookies.get("siteInfo"),
              "filed": "site_id",
              "expression": "="
            },
            {
              "condition": "1",
              "filed": "status",
              "expression": "="
            }
          ],
          "limit": 6,
          "order": "orderby asc",

        }
      };
      getProductTypeNavList(params).then(res => {
        if (res.rsp.code === 0) {
          this.productChoosedList = res.data.list;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.no-data {
  width: 100%;
  height: 80px;
  line-height: 80px;
  text-align: center;
  border: 1px solid #f5f5f5;
}

.first {
  padding: 2.25rem 1.5rem;
  color: #fff;
  .left {
    width: 20%;
    .active {
      width: 0.375rem;
      height: 3.125rem;
      background: #635796;
    }
    .yjt {
      width: 4.375rem;
      height: 1.5rem;
      margin: 0.75rem 0 0 0.25rem;
    }
  }
  .right {
    width: 100%;
    position: relative;
    .pContent {
      display: inline-block;
      width: 33.3%;
      text-align: center;
      margin: 1rem 0 ;
      .pImg {
        width: 256px;
        border-radius: 1rem;
        border: 1.5px dashed;
      }
      .pName {
        font-size: 1.1428rem;
        color: #ffffff;
        line-height: 1.875rem;
        margin: 1rem 0 ;
        text-align: center;
        cursor: pointer;
      }
    }
    .rFooter {
      position: absolute;
      bottom: -1rem;
      right: 2.5rem;
  }
  }

}
</style>
